import React, { useState } from "react";
import ReactApexChart from "react-apexcharts";
import Tooltip from "@mui/material/Tooltip";
import useWindowDimensions, { humanReadable } from "../../../../../utils/useWindowDimensions";
import { EnlargeIcon } from "../../../../../assets/icons/iconshere";
import LargeATPChart from "./ChartModals/LargeATPChart";


const AvgTimePerPerson = ({ analytics, setAPTEnlarge }) => {
  let { width, height } = useWindowDimensions();
  const { duration } = analytics;
  const chartData = {
    series: [
      {
        name: "Time",
        data: analytics.userCharts.map((e) => e.averageTime.all.average.inSeconds),
      },
    ],
    options: {
      chart: {
        type: "bar",
        width: "100%",
        toolbar: {
          show: false,
        },
      },
      plotOptions: {
        bar: {
          borderRadius: 3,
          horizontal: false,
          columnWidth: "35%",
        },
      },
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        categories: analytics.userCharts.map((e) => e.name.split(" ")[0]),
      },
      yaxis: {
        labels: {
            show: false,
            formatter: (value , index) => {
                return humanReadable(value);
            }
        }
    },
      colors: ["#3e4095"],
      tooltip: {
        y: {
          formatter: (value) => humanReadable(value),
        },
        x: {
          formatter: (value, { dataPointIndex }) => {
            return analytics.userCharts[dataPointIndex].name;
          }
        }
      }
    },
  };

  return (
    <>
      <div className="cardbox overflow-hidden">
        <div className="d-flex justify-content-between align-items-center mt-1">
          <h5 className="mb-1 pb-0 "> Average time per person</h5>
          <p className="text_enlarge_option mb-1 ">
              Total Time : {duration.all.average.humanReadable}
              <Tooltip title="View more">
              <span className="enlargebtn" onClick={()=>setAPTEnlarge(true)}>
                <EnlargeIcon/>
              </span>
              </Tooltip>
          </p>
        </div>
              <div className='chartlegends'>
              <p>Guided : {duration.guided.average.humanReadable} </p>
              <p>Unguided : {duration.unguided.average.humanReadable}  </p>
            </div>
        <div id="chart">
          <ReactApexChart
            options={chartData.options}
            series={chartData.series}
            type="bar"
            height={width > 1500 ? 350 : 320}
          />
        </div>
      </div>

    </>
  );
};

export default AvgTimePerPerson;
